// Libs
import { setMessageList } from '@/redux/reducers/socket'
import { isArray } from 'lodash-es'

// Constants
import { WS_EVENT_CHAT } from '@/constants/socketEvent'
import { VALID_BRAND_NAME } from '@/constants/brand'

// Types
import { IMessage } from '../handleMessageReceive'

const chat = {
  action({ message, brandName, silentUserList = [] }: IMessage) {
    if (message.ssid === WS_EVENT_CHAT.GROUP) {
      return handleChatReceive({ message, brandName, silentUserList })
    }
  },
}

export default chat

const parseMessageBody = (body: string) => JSON.parse(body)

const handleChatReceive = ({ message, brandName, silentUserList = [] }: any) => {
  const body = isArray(message.body) ? message.body : [message.body]

  return body?.map((item: any) => {
    const data = parseMessageBody(item as any) // TODO:

    const { msg, extra, sender } = data

    const extraData = extra ? JSON.parse(extra) : {}

    let isHiddenMessage = false

    // 針對 PXEC 品牌直播間，標記被 ban 的用戶留言
    if (brandName === VALID_BRAND_NAME.PXEC && silentUserList.length > 0) {
      const userToken = extraData?.token || sender
      if (silentUserList.includes(userToken)) {
        isHiddenMessage = true
      }
    }

    const messageData = {
      name: extraData?.name, // chat 的 name 不從 from 裡面拿，送的時候改成放在 extra 裡
      context: msg,
      isHiddenMessage,
      type: 'chat',
      isHost: extraData?.isHost,
      sort: -1,
      sender,
      extra: extraData, // 保存 extra 以便後續使用
      token: extraData?.token || sender, // 保存 token 以便識別用戶
    }

    return setMessageList({ messageData })
  })
}
